/* -----　▼ たかくらのおすすめセット ▼ ----- */
// セット内容をカートに表示する
function printOrder() {
  $("#variant_picker_01").val($("#bundled_variant_product_title li:nth-child(1)").text().replace(/\s+/g, ""));
  $("#variant_picker_02").val($("#bundled_variant_product_title li:nth-child(2)").text().replace(/\s+/g, ""));
  $("#variant_picker_03").val($("#bundled_variant_product_title li:nth-child(3)").text().replace(/\s+/g, ""));
  $("#variant_picker_04").val($("#bundled_variant_product_title li:nth-child(4)").text().replace(/\s+/g, ""));
  $("#variant_picker_05").val($("#bundled_variant_product_title li:nth-child(5)").text().replace(/\s+/g, ""));
  $("#variant_picker_06").val($("#bundled_variant_product_title li:nth-child(6)").text().replace(/\s+/g, ""));
  $("#variant_picker_07").val($("#bundled_variant_product_title li:nth-child(7)").text().replace(/\s+/g, ""));
  $("#variant_picker_08").val($("#bundled_variant_product_title li:nth-child(8)").text().replace(/\s+/g, ""));
  $("#variant_picker_09").val($("#bundled_variant_product_title li:nth-child(9)").text().replace(/\s+/g, ""));
  $("#variant_picker_10").val($("#bundled_variant_product_title li:nth-child(10)").text().replace(/\s+/g, ""));
}
$(window).on("load", printOrder());

/* -----　▼ 選べるセット ▼ ----- */
let selection = $("#shopify-section-template--21214316134700__main .product__accordion:last-of-type li"); // 「おすすめのお惣菜」リスト
let selectionTxt = [];
$(selection).each(function(){ // おすすめセットの商品名を配列に追加する
  selectionTxt.push($(this).text());
});
function printStar() {
  $("#simple-bundles-io-options option").each(function(){ // おすすめセットに含まれる商品名に「★」をつける
    if ((selectionTxt).indexOf($(this).val()) > -1) {
      $(this).text("★" + $(this).val());
    }
  });
}
$(window).on("load", function() {
  printStar();
  setTimeout(printStar, 1000);
  setTimeout(printStar, 3000);
  setTimeout(printStar, 5000);
});